







import axios from 'axios'
import * as utils from '@ivy/fts/utils'
import * as iUtils from './util'
import { wxConfigReady } from '@ivy/fts/weixin'
import { Component, Vue, Watch } from 'vue-property-decorator'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
@Component({})
export default class App extends Vue {
  name = 'app'
  async created() {
    // await wxConfigReady()
    // await this.$store.login(this)
    // this.$axios.get('/api/m-course/sample/hello')
  }
}
console.log('Powered by ivydad')
